export const SpaceTemplatesRepository = Symbol('SpaceTemplatesRepository');
